import styled from 'styled-components';
import { LoadingButton } from '@mui/lab';
import { theme } from '../../styles/theme';
export const Wrapper = styled(LoadingButton) `
  && {
    ${theme.typography.button};
    border-radius: ${theme.spacing.xs};
    box-shadow: none;
    color: ${theme.colors.textBrand};
    cursor: pointer;
    height: 42px;
    min-width: 0;
    padding: calc(${theme.spacing.xs} + 1px) ${theme.spacing.lg}
      calc(${theme.spacing.xs} + 2px);
    text-transform: none;
    // large size
    &.MuiButton-sizeLarge {
      ${theme.typography.headingSM};
      height: 64px;
    }

    // contained
    &.MuiButton-contained {
      background-color: ${({ $inverted }) => $inverted
    ? theme.colors.backgroundPrimary
    : theme.colors.buttonBackgroundDefault};
      color: ${({ $inverted }) => $inverted ? theme.colors.textBrand : theme.colors.textInverted};

      &:hover {
        background-color: ${({ $inverted }) => $inverted ? 'initial' : theme.colors.buttonBackgroundHover};
        box-shadow: none;
      }

      &:active {
        background-color: ${({ $inverted }) => $inverted ? 'initial' : theme.colors.buttonBackgroundActive};
      }

      &.Mui-disabled {
        background-color: ${({ $inverted }) => $inverted ? 'initial' : theme.colors.buttonBackgroundDisabled};

        &:not(.MuiLoadingButton-loading) {
          color: ${theme.colors.buttonTextDisabled};
        }

        // icon
        svg {
          color: ${theme.colors.buttonTextDisabled};
        }
      }

      // icon
      svg {
        color: ${({ $inverted }) => $inverted ? theme.colors.textBrand : theme.colors.textInverted};
      }
    }

    &.MuiButton-containedError {
      background-color: ${theme.colors.errorForeground};

      &:hover {
        background-color: ${theme.colors.errorForeground};
      }

      &:active {
        background-color: ${theme.colors.errorForeground};
      }
    }

    &.MuiButton-containedSecondary {
      background-color: ${theme.colors.buttonSecondaryBackgroundDefault};
      color: ${theme.colors.textBrand};

      &:hover {
        background-color: ${theme.colors.buttonSecondaryBackgroundHover};
      }

      &:active {
        background-color: ${theme.colors.buttonSecondaryBackgroundActive};
      }
    }

    // outlined / text
    &.MuiButton-outlined,
    &.MuiButton-text {
      background-color: ${theme.colors.buttonOutlinedBackgroundDefault};
      border-color: ${theme.colors.buttonBackgroundDefault};
      border-width: 1px;
      color: ${theme.colors.buttonTextDefault};

      &:hover {
        background-color: ${theme.colors.buttonOutlinedBackgroundHover};
      }

      &:active {
        background-color: ${theme.colors.buttonOutlinedBackgroundActive};
      }

      &.Mui-disabled {
        border-color: ${theme.colors.buttonOutlinedBorderDisabled};

        &:not(.MuiLoadingButton-loading) {
          color: ${theme.colors.buttonOutlinedTextDisabled};
        }
      }

      &.MuiButton-outlinedError {
        border-color: ${theme.colors.errorForeground};
        color: ${theme.colors.errorForeground};
      }

      &.MuiLoadingButton-loading {
        color: transparent !important;
      }

      // icon
      svg {
        color: ${theme.colors.textBrand};
      }
    }

    // text
    &.MuiButton-text {
      border-width: 0;
      padding-inline: ${theme.spacing.md};
    }

    // icon
    svg {
      font-size: 18px;
    }
  }
`;
